module.exports = __webpack_public_path__ + "media/images/ticket-partners/parter-281519252ceea07153b86496729003c6.svg";